module.exports = __webpack_public_path__ + "static/img/empty@3x.763bbdb8.png";